import React, { useCallback, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Popup from 'popup/Popup';
import { customAxiosPostFunction } from 'utils/axiosFunction';

import { PasswordPopupContainer } from './DeleteModulePopup.css';

const DeleteModulePopup = ({ module, dataReloadFunc, children }) => {
  const history = useHistory();
  const [popupOpen, setPopupOpen] = useState(false);
  const inputEl = useRef(null);
  const deleteModuleFunction = useCallback(async () => {
    const modelNo = inputEl.current.value;
    if (modelNo !== module.modelNo) {
      alert('올바른 모델명을 입력해주세요.');
      return false;
    }

    customAxiosPostFunction(history, '/api/module/delete', { moduleIdx: module.moduleIdx })
      .then((response) => {
        if (response !== null && response !== 0) {
          alert('삭제가 완료되었습니다.');
          dataReloadFunc();
          setPopupOpen(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [module.moduleIdx]);

  return (
    <Popup
      trigger={children}
      modal
      open={popupOpen}
      onOpen={() => {
        setPopupOpen(true);
      }}
    >
      <PasswordPopupContainer>
        <div>
          장치를 삭제하시면 다시 <span style={{ color: '#fd1100' }}>복구</span>할 수 없습니다.
        </div>
        <div>
          계속 진행하시려면 <span style={{ color: '#fd1100' }}>모델명</span>을 입력해주세요.
        </div>
        <div>
          모델명 : <input type="text" ref={inputEl} />
        </div>
        <div>
          <button
            className="btn btn-primary"
            onClick={() => {
              deleteModuleFunction();
            }}
          >
            삭제
          </button>
        </div>
      </PasswordPopupContainer>
    </Popup>
  );
};

export default React.memo(DeleteModulePopup);
